import React from "react";
import { Calendar } from "@phosphor-icons/react";
import { DATE_RANGE_PRESETS } from "./leadsConstants";

/** Preset buttons + optional Clear button + from/to date inputs. */
export default function LeadsDateRange({
  dateFrom, setDateFrom, dateTo, setDateTo, onDateRangePreset,
}) {
  const hasRange = dateFrom || dateTo;
  return (
    <div className="border-t border-zinc-300 pt-3">
      <div className="flex items-center gap-2 mb-2">
        <Calendar size={14} weight="bold" />
        <span className="label-mono">Date range</span>
        <span className="ml-2 flex gap-1">
          {DATE_RANGE_PRESETS.map((r) => (
            <button key={r.label}
              onClick={() => onDateRangePreset(r.days)}
              data-testid={`date-range-${r.label.toLowerCase()}`}
              className="border border-black px-2 py-0.5 text-[10px] uppercase tracking-widest hover:bg-black hover:text-white">
              {r.label}
            </button>
          ))}
          {hasRange && (
            <button onClick={() => { setDateFrom(""); setDateTo(""); }}
              data-testid="date-range-clear"
              className="border border-zinc-500 text-zinc-600 px-2 py-0.5 text-[10px] uppercase tracking-widest hover:bg-zinc-200">
              Clear
            </button>
          )}
        </span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <div>
          <label className="label-mono">From</label>
          <input type="date" data-testid="filter-date-from"
            className="w-full border border-black px-2 py-1.5 mt-1 font-mono"
            value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
        </div>
        <div>
          <label className="label-mono">To</label>
          <input type="date" data-testid="filter-date-to"
            className="w-full border border-black px-2 py-1.5 mt-1 font-mono"
            value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
        </div>
      </div>
    </div>
  );
}
